import { render } from "./swiperTool.vue?vue&type=template&id=3d6d64d4&scoped=true"
import script from "./swiperTool.vue?vue&type=script&lang=js"
export * from "./swiperTool.vue?vue&type=script&lang=js"

import "./swiperTool.vue?vue&type=style&index=0&id=3d6d64d4&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-uk-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d6d64d4"]])

export default __exports__